<template>

  <div class="wrap">

    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>
    <!-- 头部 -->
    <div class="section-one header-bg">
      <!-- <img src="../../img/life/new/header-bg.jpg" /> -->
      <!-- <div class="top-breadcrumb nav-bar"> -->
      <div class="nav-bar">
        <!-- <div class="nav-bar_label">ENJOY THE WATER LIFE</div> -->
        <div class="nav-bar_label">Water life enjoyment</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>舒享水生活</span>知水擅水
        </div>
        <!-- <img src="../../img/life/new/nav-top.png" class="life" /> -->
      </div>

      <img src="../../img/life/header-title.png" class="v-c-title life" />
    </div>
    <!-- Part-1 -->
    <div class="section-one part-1-bg">
      <!-- <img src="../../img/life/new/part-1-bg.jpg" class="bg" /> -->
      <div class="pic-info">
        <img src="../../img/life/new/part-1-info.png" />
      </div>
    </div>
    <!-- Part-2 -->
    <div class="section-one part-2-bg">
      <!-- <img src="../../img/life/new/part-2-bg.jpg" class="bg" /> -->
      <div class="pic-info two">
        <img src="../../img/life/new/part-2-info-1.png" />
        <img src="../../img/life/new/part-2-info-2.png" />
      </div>
    </div>
    <!-- Part-3 -->
    <div class="section-one part-3-bg">
      <!-- <img src="../../img/life/new/part-3-bg.jpg" class="bg" /> -->
      <img src="../../img/life/new/part-3-title.png" class="v-c-title life-part-3" />
    </div>
    <!-- Part-4 -->
    <div class="section-life">
      <img src="../../img/life/new/part-4-info.png" class="info" />
    </div>
    <!-- Part-5 -->
    <div class="section-one part-5-bg">
      <!-- <img src="../../img/life/new/part-5-bg.jpg" class="bg" /> -->
      <img src="../../img/life/new/part-5-title.png" class="v-c-title life-part-5" />
    </div>
    <!-- Part-6 -->
    <div class="section-one part-6-bg">
      <!-- <img src="../../img/life/new/part-6-bg.jpg" class="bg" /> -->
      <a href="/appointment"><img src="../../img/life/new/part-6-btn.png" class="v-c-title life-part-6" /></a>
    </div>

    <Footer />

  </div>

</template>

<script>
// import $ from 'jquery'
// import { Form, Field } from 'vant';
import { Toast } from "vant";
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
  },
  methods: {
    openYuyue() {
      this.yuyue = true;
    },
    onChoose(id) {
      // let id = e.target.dataset.id
      console.log(id)
      this.chooseId = id
    },
    onSubmit(values) {
      console.log('submit', values);
      Toast("提交成功！");
      this.yuyue = false
    },
    onConfirm(date) {
      this.value = `${date.getMonth() + 1}/${date.getDate()}`;
      this.showCalendar = false;
    }
  }
};
</script>

<style lang="less">
.header-bg {
  width: 100%;
  height: 1176px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/header-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-1-bg {
  width: 100%;
  height: 638px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/part-1-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-2-bg {
  width: 100%;
  height: 1218px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/part-2-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-3-bg {
  width: 100%;
  height: 646px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/part-3-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-5-bg {
  width: 100%;
  height: 897px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/part-5-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.part-6-bg {
  width: 100%;
  height: 696px;
  box-sizing: border-box;
  background-image: url('../../img/life/new/part-6-bg.jpg');
  background-size: 100% auto;
  background-position: center center;
}
.pic-info {
  width: 1100px;
  // height: 723px;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: space-between;
  &.two {
    height: 900px;
    flex-direction: column;
  }
}
</style>